<template>
    <modal
        class="modal" 
        printButton 
        downloadButton 
        :close="close" 
        :title="title" 
        :printStyle="printStyle"
        :htmlForPrint="htmlForPrint"
    >
        <h3 class="modal__header" slot="modalHeader"><i class="uk-icon-bar-chart"></i> Бизнес-коэффициенты</h3>

        <div class="modal__body" slot="modalBody" ref="htmlContent">
            <business-index-table
                v-if="years.length && targetObj" 
                :years="years" 
                :targetObj="targetObj"
                inModal
                ref="table" 
            />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import businessIndexTable from '@/components/card/businessIndex/businessIndexTable.vue'

export default {
    props: {
        years: {
            type: Array,
            default: []
        },
        targetObj: {
            type: Object,
            default: {}
        },
        title: {
            type: String,
            default: ''
        },
        printStyle: {
            type: String,
            default: ''
        },
        htmlForPrint: {
            type: String,
            default: ''
        }
    },
    components: {
        modal,
        businessIndexTable
    },
    methods: {
        close() { this.$emit('close') }
    }
}
</script>

<style lang="sass" scoped>
.modal
    &__body
        padding: 20px
</style>